import { render, staticRenderFns } from "./NewsDetails.vue?vue&type=template&id=661bb4b0&scoped=true&"
import script from "./NewsDetails.vue?vue&type=script&lang=js&"
export * from "./NewsDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetails.vue?vue&type=style&index=0&id=661bb4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661bb4b0",
  null
  
)

export default component.exports